import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import WebhooksSendMessageLogs from '../../api/webhooksSendMessageLogs';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    perPage: 15,
    totalEntries: 0,
  },
  uiFlags: {
    fetchingList: false,
  },
};

const getters = {
  getWebhooksSendMessagesLogs(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
};

const actions = {
  async fetch({ commit }, { page } = {}) {
    commit(types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS_UI_FLAG, { fetchingList: true });
    try {
      const response = await WebhooksSendMessageLogs.get({ page });
      const { webhook_logs: logs = [] } = response.data;
      const {
        total_entries: totalEntries,
        per_page: perPage,
        current_page: currentPage,
      } = response.data;
      commit(types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS, logs);
      commit(types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS_META, {
        totalEntries,
        perPage,
        currentPage,
      });
      commit(types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS_UI_FLAG, { fetchingList: false });
      return logs;
    } catch (error) {
      commit(types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },
};

const mutations = {
  [types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS]: MutationHelpers.set,
  [types.default.SET_WEBHOOKS_SEND_MESSAGES_LOGS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
